<template>
  <div class="page__agency_plan a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <div style="padding-left: 5px">
        <!--        <p class="text-primary" style="font-weight: bold; font-size: 20px">Kế Hoạch Agency</p>-->
        <el-tabs v-model="tab">
          <el-tab-pane label="Lập kế hoạch" name="plan"></el-tab-pane>
          <el-tab-pane label="Kết quả thực hiện" name="result"></el-tab-pane>
          <el-tab-pane label="Báo cáo tổng hợp" name="report"></el-tab-pane>
          <!--          <el-tab-pane label="Lập kế hoạch theo Target" name="plan_target"></el-tab-pane>-->
        </el-tabs>
      </div>

      <div :style="tab === 'plan' ? 'display: block' : 'display: none'">
        <el-row style="margin-top: 20px; padding-left: 5px">
          <el-col :sm="20">
            <div style="display: inline-block; margin-right: 10px">
              <strong style="font-size: 13px">{{ $t('select.shop') }}</strong><br>
              <el-select size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected"
                         :disabled="loading.get_metrics" filterable>
                <el-option-group :label="$t('shop.added')">
                  <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                             :label="`${item.username} ${item.name}`" :value="item._id">
                    <div>
                      <table style="width:100%;">
                        <tbody>
                        <tr>
                          <td style="width:40px;">
                            <img style="width:28px; height:28px; border-radius: 50vh;"
                                 :src="logo_channel(item.channel)"
                                 alt="image">
                          </td>
                          <td style="padding-left:10px;">
                            {{ item.username }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </el-option>
                </el-option-group>
                <el-option-group :label="$t('shop.managed')">
                  <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                             :label="`${item.username} ${item.name}`" :value="item._id">
                    <div>
                      <table style="width:100%;">
                        <tbody>
                        <tr>
                          <td style="width:40px;">
                            <img style="width:28px; height:28px; border-radius: 50vh;"
                                 :src="logo_channel(item.channel)"
                                 alt="image">
                          </td>
                          <td style="padding-left:10px;">
                            {{ item.username }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
            <div style="display: inline-block">
              <strong style="font-size: 13px">Chọn thời gian tham chiếu</strong><br>
              <el-select id="select-month" size="small" value="" :placeholder="$t('input.time')" v-model="time_type"
                         @change="m__get_metrics()" :disabled="loading.get_metrics" filterable>
                <el-option value="past30days" label="30 ngày qua"></el-option>
                <el-option value="month" label="Chọn theo tháng"></el-option>
              </el-select>&nbsp;&nbsp;
              <template v-if="time_type === 'month'">
                <el-select id="select-month" size="small" value="" placeholder="Chọn tháng" v-model="month"
                           @change="m__get_metrics()" :disabled="loading.get_metrics" filterable>
                  <el-option v-for="item of months" :key="item" :value="item" :label="`Tháng ${item + 1}`"></el-option>
                </el-select>&nbsp;&nbsp;
                <el-select size="small" value="" placeholder="Chọn năm" v-model="year" @change="m__get_metrics()"
                           :disabled="loading.get_metrics" filterable>
                  <el-option v-for="item of years" :key="item" :value="item" :label="item"></el-option>
                </el-select>
              </template>
            </div>
          </el-col>
          <el-col :sm="4" class="text-right">
            <strong style="font-size: 13px">&nbsp;</strong><br>
            <el-button size="small" type="primary" icon="el-icon-s-order" @click="m__show_agency_file_dialog">
              Danh sách file Agency
            </el-button>
          </el-col>
        </el-row>

        <el-row style="margin-top: 30px; padding-left: 5px">
          <strong class="text-primary" style="font-size: 13px">Dữ liệu tham chiếu
          </strong>
          <strong v-if="loading.get_metrics" class="text-warning"> - <i class="el-icon-loading"></i> {{ $t('base.loading_data') }}
          </strong>
          <br>
          <br>
          <div class="table-responsive">
            <table class="plan-table-normal table">
              <tr style="width: 100%">
                <th style=" font-size: 13px">Tổng quát</th>
                <th style=" font-size: 13px"></th>
                <th style=" font-size: 13px">Quảng cáo</th>
                <th style=" font-size: 13px"></th>
                <th style=" font-size: 13px">Combo Khuyến mãi</th>
                <th style=" font-size: 13px"></th>
                <th style=" font-size: 13px">Voucher</th>
                <th style=" font-size: 13px"></th>
                <th style=" font-size: 13px">Flash Sale Shop</th>
                <th style=" font-size: 13px"></th>
                <!--                <th style=" font-size: 13px">Deal Sock</th>
                                <th style=" font-size: 13px"></th>-->
              </tr>
              <tr>
                <td colspan="6">
                  <div style="height: 12px"></div>
                </td>
              </tr>
              <tr>
                <td>Doanh thu</td>
                <td>{{ gmv | format_currency(false) }}</td>
                <td>Doanh thu</td>
                <td>{{ gmv_ads | format_currency(false) }}</td>
                <td>Doanh thu</td>
                <td>{{ gmv_combo | format_currency(false) }}</td>
                <td>Doanh thu</td>
                <td>{{ gmv_voucher | format_currency(false) }}</td>
                <td>Doanh thu</td>
                <td>{{ gmv_flash_sale | format_currency(false) }}</td>
              </tr>
              <tr>
                <td colspan="6">
                  <div style="height: 12px"></div>
                </td>
              </tr>
              <tr>
                <td>AOV</td>
                <td>{{ aov | format_currency(false) }}</td>
                <td>AOV</td>
                <td>{{ aov_ads | format_currency(false) }}</td>
                <td>AOV</td>
                <td>{{ aov_combo | format_currency(false) }}</td>
                <td>AOV</td>
                <td>{{ aov_voucher | format_currency(false) }}</td>
                <td>AOV</td>
                <td>{{ aov_flash_sale | format_currency(false) }}</td>
              </tr>
              <tr>
                <td colspan="6">
                  <div style="height: 12px"></div>
                </td>
              </tr>
              <tr>
                <td>Đơn hàng</td>
                <td>{{ order | format_currency(false) }}</td>
                <td>Đơn hàng</td>
                <td>{{ order_ads | format_currency(false) }}</td>
                <td>Đơn hàng</td>
                <td>{{ order_combo | format_currency(false) }}</td>
                <td>Đơn hàng</td>
                <td>{{ order_voucher | format_currency(false) }}</td>
                <td>Đơn hàng</td>
                <td>{{ order_flash_sale | format_currency(false) }}</td>
              </tr>
              <tr>
                <td colspan="6">
                  <div style="height: 12px"></div>
                </td>
              </tr>
              <tr>
                <td>Traffic</td>
                <td>{{ traffic | format_currency(false) }}</td>
                <td>Click</td>
                <td>{{ traffic_ads | format_currency(false) }}</td>
                <td>Người mua</td>
                <td>{{ traffic_combo | format_currency(false) }}</td>
                <td>Tỉ lệ sử dụng</td>
                <td>{{ traffic_voucher | format_currency(false) }}</td>
                <td>Lượt click</td>
                <td>{{ traffic_flash_sale | format_currency(false) }}</td>
              </tr>
              <tr>
                <td colspan="6">
                  <div style="height: 12px"></div>
                </td>
              </tr>
              <tr>
                <td>CR (%)</td>
                <td>{{ cr }}%</td>
                <td>CR (%)</td>
                <td>{{ cr_ads }}%</td>
                <td>CR (%)</td>
                <td>{{ cr_combo }}%</td>
                <td>CR (%)</td>
                <td>{{ cr_voucher }}%</td>
                <td>CR (%)</td>
                <td>{{ cr_flash_sale }}%</td>
              </tr>
              <tr>
                <td colspan="6">
                  <div style="height: 12px"></div>
                </td>
              </tr>
              <td></td>
              <td></td>
              <td>Chi phí</td>
              <td>{{ cost_ads | format_currency(false) }}</td>
              <td>Chi phí</td>
              <td>{{ cost_combo | format_currency(false) }}</td>
              <td>Chi phí</td>
              <td>{{ cost_voucher | format_currency(false) }}</td>
              <td>Chi phí</td>
              <td>{{ cost_flash_sale | format_currency(false) }}</td>
            </table>
          </div>

          <el-row style="margin-top: 20px">
            <strong style="color: grey">
              Tổng chi phí: <span
              class="text-danger">{{ cost_ads + cost_combo + cost_voucher + cost_flash_sale | format_currency }}</span>
            </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong style="color: grey">
              Chi phí Ads / GMV Ads: <span
              class="text-danger">{{ +gmv_ads ? (cost_ads * 100 / gmv_ads).toFixed(2) : '0.00' }} %</span>
            </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong style="color: grey">
              Chi phí Ads / GMV: <span class="text-danger">{{
                +gmv ? (cost_ads * 100 / gmv).toFixed(2) : '0.00'
              }} %</span>
            </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong style="color: grey">
              GMV Ads / GMV: <span class="text-danger">{{ +gmv ? (gmv_ads * 100 / gmv).toFixed(2) : '0.00' }} %</span>
            </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong style="color: grey">
              Tổng chi phí / GMV: <span class="text-danger">{{
                +gmv ? ((cost_ads + cost_combo + cost_voucher + cost_flash_sale) * 100 / gmv).toFixed(2) : '0.00'
              }} %</span>
            </strong>
          </el-row>
        </el-row>

        <div style="margin-top: 35px; padding-left: 5px">
          <strong class="text-primary" style="font-size: 13px">Thông tin kỳ vọng</strong>

          <el-row style="margin-top: 10px">
            <el-col :sm="3" style="margin-right: 15px">
              <strong>Chọn tháng:</strong><br>
              <el-select size="mini" v-model="expected_month" class="full-w" placeholder="Chọn tháng" value filterable>
                <el-option v-for="item in expected_months" :key="item" :value="item" :label="`Tháng ${item + 1}`"></el-option>
              </el-select>
            </el-col>
            <el-col :sm="3" style="margin-right: 15px">
              <strong>GMV kỳ vọng:</strong><br>
              <el-input type="number" size="mini" v-model="expected_gmv" placeholder="Doanh thu kỳ vọng"></el-input>
              <small class="text-danger">GMV: {{ expected_gmv | format_currency(false) }}</small>
            </el-col>
            <el-col :sm="3" style="margin-right: 15px">
              <strong>GMV Ads kỳ vọng:</strong><br>
              <el-input type="number" size="mini" v-model="expected_gmv_ads" placeholder="Doanh thu kỳ vọng"></el-input>
              <small class="text-danger">GMV Ads: {{ expected_gmv_ads | format_currency(false) }}</small>
            </el-col>
            <el-col :sm="3" style="margin-right: 15px">
              <strong>Chi phí Ads kỳ vọng:</strong><br>
              <el-input type="number" size="mini" v-model="expected_cost" placeholder="Chi phí kỳ vọng"
                        @keyup.enter.native="m__generate_expected()"></el-input>
              <small class="text-danger">Chi phí Ads: {{
                  m__calculate_expected_cost() | format_currency(false)
                }}</small>
            </el-col>
            <el-col :sm="3" style="margin-right: 15px">
              <strong>&nbsp;</strong><br>
              <el-select style="width: 130px" class="full-w" size="mini" v-model="expected_cost_type" value filterable>
                <el-option value="cost" label="Theo giá tiền"></el-option>
                <el-option value="percent" label="Theo phần trăm"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 30px; padding-left: 5px">
          <div id="double-scroll-wrapper" style="position: fixed; z-index: 2000; bottom: 1px;">
            <div id="double-scroll-bar">
            </div>
          </div>

          <br>
          <strong class="text-primary" style="font-size: 13px">Chi tiết phân bổ theo ngày</strong>
          <br>
          <br>
          <el-row>
            <el-col :sm="20">
              <el-select size="mini" value v-model="divided">
                <el-option value="1" label="Chia đều cho ngày không có Event"></el-option>
                <el-option value="2" label="Chia đều cho tất cả"></el-option>
              </el-select>
              &nbsp;&nbsp;
              <el-button type="info" size="mini" icon="el-icon-download" @click="export_file_excel">Tải file Excel
              </el-button>
              <el-button type="info" size="mini" @click="m__show_update_column_dialog">{{ $t('base.mass_update') }}</el-button>
              <el-button type="info" size="mini" @click="m__show_copy_column_dialog">Sao chép cột</el-button>
              <el-button type="info" size="mini" icon="el-icon-files" @click="m__show_agency_filename_dialog">Lưu file
              </el-button>
            </el-col>
            <el-col :sm="4" class="text-right">
              <el-button type="primary" size="mini" icon="el-icon-check" @click="m__generate_expected"
                         :loading="loading.generate_data">
                Tạo dữ liệu chi tiết
              </el-button>
            </el-col>
          </el-row>

          <el-table id="main-table-plan-fixed" :data="[]" :cell-class-name="m__cell_style"
                    :header-cell-class-name="m__header_style">
            <el-table-column fixed label="#" prop="index" width="40px"></el-table-column>
            <el-table-column fixed label="Ngày" prop="time" width="100px"></el-table-column>
            <el-table-column label="Shopee Event" prop="event" width="120px" resizable show-tooltip-when-overflow>
              <template slot-scope="scope">
                <template v-if="!scope.row.is_first">
                  <el-input v-if="scope.row.editable" size="mini" class="invisible-input" v-model="scope.row.event"
                            @blur="scope.row.editable = false" v-focus></el-input>
                  <div v-else class="cell-not-editable" @click="scope.row.editable = true">
                    {{ scope.row.event }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="`Số liệu tham khảo ${month && year ? `(Tháng ${month + 1}/${year})` : ''}`"
                             align="center">
              <el-table-column label="GMV" prop="gmv" min-width="140px">
                <template slot-scope="scope">{{ scope.row.gmv | format_currency(false) }}</template>
              </el-table-column>
              <el-table-column label="GMV Ads" prop="gmv_ads" min-width="140px">
                <template slot-scope="scope">{{ scope.row.gmv_ads | format_currency(false) }}</template>
              </el-table-column>
              <el-table-column label="AOV" prop="aov" min-width="140px">
                <template slot-scope="scope">{{ scope.row.aov | format_currency(false) }}</template>
              </el-table-column>
              <el-table-column label="Order" prop="order" min-width="90px"></el-table-column>
              <el-table-column label="Click" prop="traffic" min-width="90px"></el-table-column>
              <el-table-column label="CR %" prop="cr" min-width="90px"></el-table-column>
            </el-table-column>
            <el-table-column label="Kế hoạch" align="center">
              <el-table-column label="Target GMV" min-width="140px" prop="target_gmv">
                <template slot="header" slot-scope="scope">
                  Target GMV <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-warning">Còn: {{ scope.row.target_gmv | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable1" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_gmv" @input="m__on_change_target_gmv(scope.row)"
                              @blur="scope.row.editable1 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable1 = true">
                      {{ scope.row.target_gmv | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Target GMV Ads" min-width="140px" prop="target_gmv_ads">
                <template slot="header" slot-scope="scope">
                  Target GMV Ads <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-warning">Còn: {{ scope.row.target_gmv_ads | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable4" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_gmv_ads" @input="m__on_change_target_gmv_ads(scope.row)"
                              @blur="scope.row.editable4 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable4 = true">
                      {{ scope.row.target_gmv_ads | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.ads_expense')" min-width="140px">
                <template slot="header" slot-scope="scope">
                  Chi phí Ads <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-danger">Còn: {{ scope.row.target_cost | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable2" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_cost" @input="m__on_change_target_cost(scope.row)"
                              @blur="scope.row.editable2 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable2 = true">
                      {{ scope.row.target_cost | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Target AOV" min-width="140px">
                <template slot="header" slot-scope="scope">
                  Target AOV <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input v-if="scope.row.editable3" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_aov" @input="m__on_change(scope.row, 'aov')"
                              @blur="scope.row.editable3 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable3 = true">
                      {{ scope.row.target_aov | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Order" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_order"
                              @input="m__on_change(scope.row, 'order')"></el-input>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Click" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_traffic"
                              @input="m__on_change(scope.row, 'traffic')"></el-input>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="CR %" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_cr"
                              @input="m__on_change(scope.row, 'cr')"></el-input>
                  </template>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-table id="main-table-plan" :data="c__show_display_data" style="margin-top: 10px"
                    v-loading="loading.generate_data" class="plan-table"
                    :cell-class-name="m__cell_style" :header-cell-class-name="m__header_style">
            <el-table-column fixed label="#" prop="index" width="40px"></el-table-column>
            <el-table-column fixed label="Ngày" prop="time" width="100px"></el-table-column>
            <el-table-column label="Shopee Event" prop="event" width="120px" resizable show-tooltip-when-overflow>
              <template slot-scope="scope">
                <template v-if="!scope.row.is_first">
                  <el-input v-if="scope.row.editable" size="mini" class="invisible-input" v-model="scope.row.event"
                            @blur="scope.row.editable = false" v-focus></el-input>
                  <div v-else class="cell-not-editable" @click="scope.row.editable = true">
                    {{ scope.row.event }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="`Số liệu tham khảo ${month && year ? `(Tháng ${month + 1}/${year})` : ''}`"
                             align="center">
              <el-table-column label="GMV" prop="gmv" min-width="90px">
                <template slot-scope="scope">{{ scope.row.gmv | format_currency(false) }}</template>
              </el-table-column>
              <el-table-column label="GMV Ads" prop="gmv_ads" min-width="90px">
                <template slot-scope="scope">{{ scope.row.gmv_ads | format_currency(false) }}</template>
              </el-table-column>
              <el-table-column label="AOV" prop="aov" min-width="90px">
                <template slot-scope="scope">{{ scope.row.aov | format_currency(false) }}</template>
              </el-table-column>
              <el-table-column label="Order" prop="order" min-width="90px"></el-table-column>
              <el-table-column label="Click" prop="traffic" min-width="90px"></el-table-column>
              <el-table-column label="CR %" prop="cr" min-width="90px"></el-table-column>
            </el-table-column>
            <el-table-column label="Kế hoạch" align="center">
              <el-table-column label="Target GMV" min-width="140px" prop="target_gmv">
                <template slot="header" slot-scope="scope">
                  Target GMV <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-warning">Còn: {{ scope.row.target_gmv | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable1" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_gmv" @input="m__on_change_target_gmv(scope.row)"
                              @blur="scope.row.editable1 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable1 = true">
                      {{ scope.row.target_gmv | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Target GMV Ads" min-width="140px" prop="target_gmv_ads">
                <template slot="header" slot-scope="scope">
                  Target GMV Ads <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-warning">Còn: {{ scope.row.target_gmv_ads | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable4" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_gmv_ads" @input="m__on_change_target_gmv_ads(scope.row)"
                              @blur="scope.row.editable4 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable4 = true">
                      {{ scope.row.target_gmv_ads | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.ads_expense')" min-width="140px">
                <template slot="header" slot-scope="scope">
                  Chi phí Ads <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-danger">Còn: {{ scope.row.target_cost | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable2" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_cost" @input="m__on_change_target_cost(scope.row)"
                              @blur="scope.row.editable2 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable2 = true">
                      {{ scope.row.target_cost | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Target AOV" min-width="140px">
                <template slot="header" slot-scope="scope">
                  Target AOV <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input v-if="scope.row.editable3" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_aov" @input="m__on_change(scope.row, 'aov')"
                              @blur="scope.row.editable3 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable3 = true">
                      {{ scope.row.target_aov | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Order" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_order"
                              @input="m__on_change(scope.row, 'order')"></el-input>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Click" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_traffic"
                              @input="m__on_change(scope.row, 'traffic')"></el-input>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="CR %" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_cr"
                              @input="m__on_change(scope.row, 'cr')"></el-input>
                  </template>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <div id="main-pagination"></div>

          <br>
          <br>
          <br>
          <el-row>
            <el-col :sm="20">
              <strong class="text-primary" style="font-size: 13px">Chi tiết phân bổ theo Sản phẩm</strong>
            </el-col>
            <el-col :sm="4">
              <el-input size="mini" v-model="product_filter.keyword"
                        :placeholder="$t('input.placeholder')"></el-input>
            </el-col>
          </el-row>
          <br>
          <br>
          <el-table id="main-table-plan-product" :data="c__show_display_data_product" style="margin-top: 10px"
                    v-loading="loading.generate_data" class="plan-table"
                    :cell-class-name="m__cell_style" :header-cell-class-name="m__header_style">
            <el-table-column :label="$t('base.product')" width="200px" prop="name" show-tooltip-when-overflow>
            </el-table-column>
            <el-table-column label="Kế hoạch" align="center">
              <el-table-column label="Target GMV" min-width="140px" prop="target_gmv">
                <template slot="header" slot-scope="scope">
                  Target GMV <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-warning">Còn: {{ scope.row.target_gmv | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable1" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_gmv" @input="m__on_change_target_gmv(scope.row)"
                              @blur="scope.row.editable1 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable1 = true">
                      {{ scope.row.target_gmv | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <!--              <el-table-column label="Target GMV Ads" min-width="140px" prop="target_gmv_ads">
                              <template slot="header" slot-scope="scope">
                                Target GMV Ads <i class="el-icon-edit"></i>
                              </template>
                              <template slot-scope="scope">
                                <template v-if="scope.row.is_first">
                                  <strong class="text-warning">Còn: {{ scope.row.target_gmv_ads | format_currency(false) }}</strong>
                                </template>
                                <template v-else>
                                  <el-input v-if="scope.row.editable4" type="number" size="mini" class="invisible-input"
                                            v-model="scope.row.target_gmv_ads" @input="m__on_change_target_gmv_ads(scope.row)"
                                            @blur="scope.row.editable4 = false" v-focus></el-input>
                                  <div v-else class="cell-not-editable" @click="scope.row.editable4 = true">
                                    {{ scope.row.target_gmv_ads | format_currency(false) }}
                                  </div>
                                </template>
                              </template>
                            </el-table-column>-->
              <el-table-column :label="$t('metric.ads_expense')" min-width="140px">
                <template slot="header" slot-scope="scope">
                  Chi phí Ads <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="scope.row.is_first">
                    <strong class="text-danger">Còn: {{ scope.row.target_cost | format_currency(false) }}</strong>
                  </template>
                  <template v-else>
                    <el-input v-if="scope.row.editable2" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_cost" @input="m__on_change_target_cost(scope.row)"
                              @blur="scope.row.editable2 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable2 = true">
                      {{ scope.row.target_cost | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Target AOV" min-width="140px">
                <template slot="header" slot-scope="scope">
                  Target AOV <i class="el-icon-edit"></i>
                </template>
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input v-if="scope.row.editable3" type="number" size="mini" class="invisible-input"
                              v-model="scope.row.target_aov" @input="m__on_change(scope.row, 'aov')"
                              @blur="scope.row.editable3 = false" v-focus></el-input>
                    <div v-else class="cell-not-editable" @click="scope.row.editable3 = true">
                      {{ scope.row.target_aov | format_currency(false) }}
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Order" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_order"
                              @input="m__on_change(scope.row, 'order')"></el-input>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="Click" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_traffic"
                              @input="m__on_change(scope.row, 'traffic')"></el-input>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="CR %" min-width="140px">
                <template slot-scope="scope">
                  <template v-if="!scope.row.is_first">
                    <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_cr"
                              @input="m__on_change(scope.row, 'cr')"></el-input>
                  </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="$t('base.optional')" width="200px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__select_data(scope.row)">Xem dữ liệu</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                         layout="prev, pager, next, total" :total="data_product.length"/>

          <br>
          <br>
          <br>
          <strong class="text-primary" style="font-size: 13px">Chi tiết phân bổ theo Target</strong>
          <br>
          <br>
          <el-button size="mini" @click="m__use_aov">Sử dụng AOV tham chiếu</el-button>
          <el-button size="mini" @click="m__use_cr">Sử dụng CR tham chiếu</el-button>
          <el-table id="main-table-plan-target" style="margin-top: 10px" :data="data_target"
                    :row-class-name="m__cell_class_name" :cell-class-name="m__cell_style"
                    :header-cell-class-name="m__header_style" v-loading="loading.generate_data">
            <el-table-column label="Kênh marketing" width="200px" prop="name"></el-table-column>
            <el-table-column :label="$t('base.sales')" align="center">
              <el-table-column label="Tỉ lệ" align="center" min-width="140px" prop="gmv_percent">
                <template slot-scope="scope">
                  <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.gmv_percent"
                            @input="m__on_change_target_plan('gmv', scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="Số tiền" align="center" min-width="140px">
                <template slot-scope="scope">
                  {{ scope.row.gmv | format_currency(false) }}
                  <!--              <el-input class="invisible-input" size="mini" v-model="scope.row.gmv"></el-input>-->
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="$t('metric.expense')" align="center">
              <el-table-column label="Tỉ lệ" align="center" min-width="140px" prop="cost_percent">
                <template slot-scope="scope">
                  <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.cost_percent"
                            @input="m__on_change_target_plan('cost', scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="Số tiền" align="center" min-width="140px">
                <template slot-scope="scope">
                  {{ scope.row.cost | format_currency(false) }}
                  <!--              <el-input class="invisible-input" size="mini" v-model="scope.row.cost"></el-input>-->
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="AOV" min-width="140px" prop="aov">
              <template slot-scope="scope">
                <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.aov"
                          @input="m__on_change_target_plan('aov', scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Order" min-width="140px">
              <template slot-scope="scope">
                <!--            <el-input class="invisible-input" size="mini" v-model="scope.row.order"></el-input>-->
                {{ scope.row.order | format_currency(false) }}
              </template>
            </el-table-column>
            <el-table-column label="CR" min-width="140px">
              <template slot-scope="scope">
                <el-input type="number" class="invisible-input" size="mini" v-model="scope.row.cr"
                          @input="m__on_change_target_plan('cr', scope.row)"></el-input>
                <!--            {{ scope.row.cr }}%-->
              </template>
            </el-table-column>
            <el-table-column label="Traffic / Click" min-width="140px">
              <template slot-scope="scope">
                <!--            <el-input class="invisible-input" size="mini" v-model="scope.row.traffic"></el-input>-->
                {{ scope.row.traffic }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!--      <div :style="tab === 'result' ? 'display: block' : 'display: none'">-->
      <div v-if="tab === 'result'">
        <AgencyResult :counter="counter"></AgencyResult>
      </div>

      <div v-if="tab === 'report'">
        <AgencyReport></AgencyReport>
      </div>

      <div v-if="tab === 'plan_target'">
        <PlanTarget></PlanTarget>
      </div>
    </div>

    <el-dialog width="300px" :close-on-click-modal="false" :visible.sync="show_dialog.copy_column"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong>Chọn cột sao chép</strong><br><br>

        <template v-for="key in Object.keys(copy_columns)">
          <el-radio v-model="copy_column" :label="key">{{ copy_columns[key] }}</el-radio>
          <br>
        </template>

        <div class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__confirm_copy_column">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="500px" :close-on-click-modal="false" :visible.sync="show_dialog.update_column"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong>{{ $t('base.mass_update') }}</strong><br><br>

        <el-radio v-model="form_update.value" label="aov">AOV</el-radio>
        <br>
        <el-input style="width:50%" type="number" size="mini" v-model="form_update.aov_value"
                  placeholder="Nhập giá trị AOV"></el-input>&nbsp;&nbsp;
        <el-select style="width: 40%" size="mini" value="" v-model="form_update.aov_type">
          <el-option v-for="key of Object.keys(form_types)" :key="key" :value="key" :label="form_types[key]"></el-option>
        </el-select>

        <br><br>

        <el-radio v-model="form_update.value" label="order">Order</el-radio>
        <br>
        <el-input style="width:50%" type="number" size="mini" v-model="form_update.order_value"
                  placeholder="Nhập giá trị Order"></el-input>&nbsp;&nbsp;
        <el-select style="width: 40%" size="mini" value="" v-model="form_update.order_type">
          <el-option v-for="key of Object.keys(form_types)" :key="key" :value="key" :label="form_types[key]"></el-option>
        </el-select>

        <br><br>

        <el-radio v-model="form_update.value" label="Click">Traffic</el-radio>
        <br>
        <el-input style="width:50%" type="number" size="mini" v-model="form_update.traffic_value"
                  placeholder="Nhập giá trị Order"></el-input>&nbsp;&nbsp;
        <el-select style="width: 40%" size="mini" value="" v-model="form_update.traffic_type">
          <el-option v-for="key of Object.keys(form_types)" :key="key" :value="key" :label="form_types[key]"></el-option>
        </el-select>

        <br><br>

        <div class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__confirm_update_column">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.create_agency_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input v-model="filename" size="mini" placeholder="Nhập tên file..."></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__save_agency_file"
                     :loading="loading.save_file">Lưu file dữ liệu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="show_dialog.agency_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 13px">Danh sách file Agency</strong>
        <el-table
          :data="agency_files.filter(i => $store.state.userInfo.username ==='vuducminhdev07' ? true : i.mipeeUserId === $store.state.userInfo.username)">
          <el-table-column :label="$t('base.filename')" prop="filename"></el-table-column>
          <el-table-column :label="$t('base.month')" prop="month" width="100px">
            <template slot-scope="scope">
              {{ `${scope.row.month + 1}/${scope.row.year}` }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.shop')" width="150px">
            <template slot-scope="scope">
              {{ m__get_shop_name(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')" width="200px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="m__use_agency_file(scope.row)" :loading="scope.row.loading">
                <strong class="text-info">{{ $t('base.use_file') }}</strong></el-button>
              <el-button type="text" size="mini" @click="m__delete_agency_file(scope.row)">
                <strong class="text-danger">Xoá</strong></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.show_data"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong class="string-title">Chi tiết dữ liệu</strong>

        <el-table id="main-table-plan" :data="selected_data" style="margin-top: 10px"
                  v-loading="loading.generate_data" class="plan-table"
                  :cell-class-name="m__cell_style" :header-cell-class-name="m__header_style">
          <el-table-column fixed label="#" prop="index" width="40px"></el-table-column>
          <el-table-column fixed label="Ngày" prop="time" width="100px"></el-table-column>
          <el-table-column label="Shopee Event" prop="event" width="120px" resizable show-tooltip-when-overflow>
            <template slot-scope="scope">
              <template v-if="!scope.row.is_first">
                <el-input v-if="scope.row.editable" size="mini" class="invisible-input" v-model="scope.row.event"
                          @blur="scope.row.editable = false" v-focus></el-input>
                <div v-else class="cell-not-editable" @click="scope.row.editable = true">
                  {{ scope.row.event }}
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="Kế hoạch" align="center">
            <el-table-column label="Target GMV" min-width="140px" prop="target_gmv">
              <template slot="header" slot-scope="scope">
                Target GMV <i class="el-icon-edit"></i>
              </template>
              <template slot-scope="scope">
                <template v-if="scope.row.is_first">
                  <strong class="text-warning">Còn: {{ scope.row.target_gmv | format_currency(false) }}</strong>
                </template>
                <template v-else>
                  <el-input v-if="scope.row.editable1" type="number" size="mini" class="invisible-input"
                            v-model="scope.row.target_gmv" @input="m__on_change_target_gmv(scope.row)"
                            @blur="scope.row.editable1 = false" v-focus></el-input>
                  <div v-else class="cell-not-editable" @click="scope.row.editable1 = true">
                    {{ scope.row.target_gmv | format_currency(false) }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="Target GMV Ads" min-width="140px" prop="target_gmv_ads">
              <template slot="header" slot-scope="scope">
                Target GMV Ads <i class="el-icon-edit"></i>
              </template>
              <template slot-scope="scope">
                <template v-if="scope.row.is_first">
                  <strong class="text-warning">Còn: {{ scope.row.target_gmv_ads | format_currency(false) }}</strong>
                </template>
                <template v-else>
                  <el-input v-if="scope.row.editable4" type="number" size="mini" class="invisible-input"
                            v-model="scope.row.target_gmv_ads" @input="m__on_change_target_gmv_ads(scope.row)"
                            @blur="scope.row.editable4 = false" v-focus></el-input>
                  <div v-else class="cell-not-editable" @click="scope.row.editable4 = true">
                    {{ scope.row.target_gmv_ads | format_currency(false) }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.ads_expense')" min-width="140px">
              <template slot="header" slot-scope="scope">
                Chi phí Ads <i class="el-icon-edit"></i>
              </template>
              <template slot-scope="scope">
                <template v-if="scope.row.is_first">
                  <strong class="text-danger">Còn: {{ scope.row.target_cost | format_currency(false) }}</strong>
                </template>
                <template v-else>
                  <el-input v-if="scope.row.editable2" type="number" size="mini" class="invisible-input"
                            v-model="scope.row.target_cost" @input="m__on_change_target_cost(scope.row)"
                            @blur="scope.row.editable2 = false" v-focus></el-input>
                  <div v-else class="cell-not-editable" @click="scope.row.editable2 = true">
                    {{ scope.row.target_cost | format_currency(false) }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="Target AOV" min-width="140px">
              <template slot="header" slot-scope="scope">
                Target AOV <i class="el-icon-edit"></i>
              </template>
              <template slot-scope="scope">
                <template v-if="!scope.row.is_first">
                  <el-input v-if="scope.row.editable3" type="number" size="mini" class="invisible-input"
                            v-model="scope.row.target_aov" @input="m__on_change(scope.row, 'aov')"
                            @blur="scope.row.editable3 = false" v-focus></el-input>
                  <div v-else class="cell-not-editable" @click="scope.row.editable3 = true">
                    {{ scope.row.target_aov | format_currency(false) }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="Order" min-width="140px">
              <template slot-scope="scope">
                <template v-if="!scope.row.is_first">
                  <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_order"
                            @input="m__on_change(scope.row, 'order')"></el-input>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="Click" min-width="140px">
              <template slot-scope="scope">
                <template v-if="!scope.row.is_first">
                  <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_traffic"
                            @input="m__on_change(scope.row, 'traffic')"></el-input>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="CR %" min-width="140px">
              <template slot-scope="scope">
                <template v-if="!scope.row.is_first">
                  <el-input type="number" size="mini" class="invisible-input" v-model="scope.row.target_cr"
                            @input="m__on_change(scope.row, 'cr')"></el-input>
                </template>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AgencyResult from './result'
import AgencyReport from './report'
import PlanTarget from './plan_target'
import {take as _take, drop as _drop, orderBy as _orderBy, filter as _filter} from 'lodash'
import store from '../../store/index'
import {get_shop_mixins} from '../../mixins/get_shop';
import {show_expr_notification} from "../../addon/check_license";

export default {
  name: 'page__agency_plan',

  mixins: [get_shop_mixins],

  components: {
    AgencyResult,
    AgencyReport,
    PlanTarget
  },

  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },

  data() {
    return {
      tab: 'plan',
      seller: null,
      years: [],
      year: this.dayjs().year(),
      months: [],
      month: null,

      time_type: 'month',

      aov: 0,
      aov_ads: 0,
      aov_combo: 0,
      aov_voucher: 0,
      aov_flash_sale: 0,
      aov_deal: 0,
      order: 0,
      order_ads: 0,
      order_combo: 0,
      order_voucher: 0,
      order_flash_sale: 0,
      order_deal: 0,
      traffic: 0,
      traffic_ads: 0,
      traffic_combo: 0,
      traffic_voucher: 0,
      traffic_flash_sale: 0,
      traffic_deal: 0,
      cr: 0,
      cr_ads: 0,
      cr_combo: 0,
      cr_voucher: 0,
      cr_flash_sale: 0,
      cr_deal: 0,
      gmv: 0,
      gmv_ads: 0,
      gmv_combo: 0,
      gmv_voucher: 0,
      gmv_flash_sale: 0,
      gmv_deal: 0,
      cost_ads: 0,
      cost_combo: 0,
      cost_voucher: 0,
      cost_flash_sale: 0,
      cost_deal: 0,

      divided: '1',
      expected_months: [],
      expected_month: null,
      expected_gmv: null,
      expected_gmv_ads: null,
      expected_cost: null,
      expected_cost_type: 'cost',

      key_metrics: {},
      metrics_ads: {},
      reports: [],
      data: [],
      data_target: [],
      data_product: [],
      interval: null,

      loading: {
        generate_data: false,
        save_file: false,
        calculate: false,
        get_metrics: false
      },
      show_dialog: {
        copy_column: false,
        update_column: false,
        create_agency_filename: false,
        agency_file: false,
        show_data: false
      },

      copy_columns: {
        aov: 'AOV',
        order: 'Order',
        traffic: 'Click',
        cr: 'CR'
        // cr: {name: 'CR', checked: false}
      },
      copy_column: 'aov',
      form_update: {
        value: 'aov',
        aov: false,
        aov_value: null,
        aov_type: 'inc',
        order: false,
        order_value: null,
        order_type: 'inc',
        traffic: false,
        traffic_value: null,
        traffic_type: 'inc'
      },
      form_types: {
        inc: 'Tăng theo giá',
        des: 'Giảm theo giá',
        inc_percent: 'Tăng theo %',
        des_percent: 'Giảm theo %',
        cost: 'Giá trị cố định'
      },
      filename: '',

      counter: 0,
      agency_files: [],
      send_request_list: [],
      spike_days: [],

      is_destroyed: false,

      product_filter: {
        page_size: 20,
        current_page: 0,
        keyword: '',
        total_record: 0,
        show: true
      },

      selected_data: []
    }
  },

  beforeRouteEnter(to, from, next) {
    if (store.state.agency_plan_list.some(i => store.state.userInfo.username.includes(i))) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_spike_days()

    this.years = []
    for (let i = this.dayjs().year(); i >= this.dayjs().year() - 2; i--) {
      this.years.push(i)
    }

    this.months = []
    const end_month = this.year >= this.dayjs().year() ? this.dayjs().month() + 1 : 12
    for (let i = 0; i < end_month; i++) {
      this.months.push(i)
    }
    this.month = this.dayjs().month() - 1 < 0 ? 0 : this.dayjs().month() - 1

    this.expected_months = []
    for (let i = 0; i < 12; i++) {
      this.expected_months.push(i)
    }
    this.expected_month = this.dayjs().month()

    await this.m__get_shopee_shop()
    await this.m__send_request_list()
    await this.m__get_agency_file()

    if (this.$route.query.shop) {
      this.tab = 'result'
    }
  },

  beforeDestroy() {
    this.is_destroyed = true
    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    dashboard_wrapper.onscroll = () => {
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    },

    'year': function (new_val, old_val) {
      this.months = []
      const end_month = this.year >= this.dayjs().year() ? this.dayjs().month() : 12
      for (let i = 0; i < end_month; i++) {
        this.months.push(i)
      }

      if (new_val !== old_val) {
        this.month = null
      }
    }
  },

  computed: {
    c__show_display_data() {
      if (this.data.length) {
        return [this.m__generate_first_of_data(), ...this.data]
      } else {
        return this.data
      }
    },

    c__show_filter_data_product() {
      const words = this.remove_unicode(this.product_filter.keyword)
      return _filter(this.data_product, item => this.remove_unicode(item.name).includes(words))
    },

    c__show_display_data_product() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.c__show_filter_data_product, skip), limit)
    }
  },

  methods: {
    m__init_start_time() {
      if (this.time_type === 'past30days') {
        return this.dayjs().subtract(30, 'day').startOf('day')
      } else {
        return this.dayjs([this.year, this.month]).startOf('month')
      }
    },

    m__init_end_time(special = false) {
      if (this.time_type === 'past30days') {
        return this.dayjs().startOf('d')
      } else {
        if (special) {
          return this.month >= this.dayjs().month() ? this.dayjs().startOf('d') : this.dayjs([this.year, this.month]).endOf('month').add(1, 'second')
        }

        return this.dayjs([this.year, this.month]).endOf('month')
      }
    },

    m__select_data(row) {
      this.selected_data = row.data
      this.show_dialog.show_data = true
    },

    async m__generate_data_product() {
      let offset = 0, limit = 50, ads_list = []

      const start_time = this.dayjs([this.dayjs().year(), this.expected_month]).startOf('month')
      const end_time = this.dayjs([this.dayjs().year(), this.expected_month]).endOf('month')

      let ads_list_resp = await this.seller.marketing_get_home_page(offset, limit, start_time.unix(), end_time.unix())
      while (ads_list_resp && ads_list_resp.data && ads_list_resp.data.campaign_ads_list && ads_list_resp.data.campaign_ads_list.length) {
        ads_list.push(...ads_list_resp.data.campaign_ads_list.filter(i => i.product.state === 'normal' && ['keyword', 'targeting'].includes(i.campaign.type)))

        offset += limit
        ads_list_resp = await this.seller.marketing_get_home_page(offset, limit, start_time.unix(), end_time.unix())
      }

      const product_list = []
      for (const item of ads_list) {
        const found = product_list.find(i => i.id === item.product.itemid)
        if (found) {
          for (const key of Object.keys(found.report)) {
            if (item.report[key]) {
              found.report[key].value = Number(found.report[key].value) + Number(item.report[key].value)
            }
          }
        } else {
          product_list.push({
            id: item.product.itemid,
            name: item.product.name,
            image: item.product.images.split(',')[0],
            report: item.report
            // ...Object.keys(item.report).map(key => ({item.report[key]+item.report[key].value}))
          })
        }
      }

      let percent = 0
      if (+this.expected_gmv_ads && +this.expected_gmv_ads > this.gmv_ads) {
        const sub = +this.expected_gmv_ads - this.gmv_ads
        percent = sub * 100 / +this.expected_gmv_ads
      }

      const data = []
      for (const product of product_list) {
        const row = {
          id: product.id,
          name: product.name,
          image: product.image,
          target_gmv: Math.floor(product.report.broad_gmv.value),
          target_gmv_ads: Math.floor(product.report.broad_gmv.value),
          target_cost: Math.floor(product.report.cost.value),
          target_aov: 0,
          target_order: Math.floor(product.report.broad_order.value),
          target_traffic: Math.floor(product.report.click.value),
          target_cr: 0,
          aov: 0,
          order: 0,
          traffic: 0,
          cr: 0,
          gmv: 0,
          gmv_ads: 0,
          data: []
        }

        if (+percent) {
          row.target_gmv = row.target_gmv + Math.floor(percent * row.target_gmv / 100)
          row.target_gmv_ads = row.target_gmv_ads + Math.floor(percent * row.target_gmv_ads / 100)
          row.target_cost = row.target_cost + Math.floor(percent * row.target_cost / 100)
          row.target_order = row.target_order + Math.floor(percent * row.target_order / 100)
          row.target_traffic = row.target_traffic + Math.floor(percent * row.target_traffic / 100)
        }

        if (row.target_order) {
          row.target_aov = Math.floor(row.target_gmv_ads / row.target_order)
        }

        if (row.target_traffic) {
          row.target_cr = +(row.target_order * 100 / row.target_traffic).toFixed(2)
        }

        data.push(row)
      }

      const total_gmv = data.reduce((t, i) => t + i.target_gmv, 0)
      if (+this.expected_gmv_ads && +this.expected_gmv_ads > total_gmv) {
        const no_gmv_count = data.filter(i => !i.target_gmv && i.target_traffic).length
        const value = Math.floor((this.expected_gmv_ads - total_gmv) / no_gmv_count)
        data.forEach(i => {
          if (!i.target_gmv && i.target_traffic) {
            i.target_gmv = value
          }
        })
      }

      const total_cost = data.reduce((t, i) => t + i.expected_cost, 0)
      if (+this.expected_cost && +this.expected_cost > total_cost) {
        const no_const_count = data.filter(i => !i.target_cost && i.target_traffic).length
        const value = Math.floor((this.expected_cost - total_cost) / no_const_count)
        data.forEach(i => {
          if (!i.target_cost && i.target_traffic) {
            i.target_cost = value
          }
        })
      }

      for (const product of data) {
        let start_time = this.dayjs([this.dayjs().year(), this.expected_month]).startOf('month')
        const end_time = this.dayjs([this.dayjs().year(), this.expected_month]).endOf('month')

        const flash_sale_gmv = Math.floor(product.target_gmv * 25 / 100)
        const flash_sale_gmv2 = Math.floor(product.target_gmv * 10 / 100)
        const avg_gmv_after = Math.floor((product.target_gmv - (flash_sale_gmv + flash_sale_gmv2)) / (end_time.date() - 2))

        const flash_sale_gmv_ads = Math.floor(product.target_gmv_ads * 25 / 100)
        const flash_sale_gmv_ads2 = Math.floor(product.target_gmv_ads * 10 / 100)
        const avg_gmv_ads_after = Math.floor((product.target_gmv_ads - (flash_sale_gmv_ads + flash_sale_gmv_ads2)) / (end_time.date() - 2))

        const flash_sale_cost = Math.floor(product.target_cost * 25 / 100)
        const flash_sale_cost2 = Math.floor(product.target_cost * 10 / 100)
        const avg_cost_after = Math.floor((product.target_cost - (flash_sale_cost + flash_sale_cost2)) / (end_time.date() - 2))

        const flash_sale_order = Math.floor(product.target_order * 25 / 100)
        const flash_sale_order2 = Math.floor(product.target_order * 10 / 100)
        const avg_order_after = Math.floor((product.target_order - (flash_sale_order + flash_sale_order2)) / (end_time.date() - 2))

        const flash_sale_traffic = Math.floor(product.target_traffic * 25 / 100)
        const flash_sale_traffic2 = Math.floor(product.target_traffic * 10 / 100)
        const avg_traffic_after = Math.floor((product.target_traffic - (flash_sale_traffic + flash_sale_traffic2)) / (end_time.date() - 2))

        let i = 1
        while (start_time.isSameOrBefore(end_time, 'd')) {
          const spike_day = this.spike_days.find(i => i.month === start_time.month() + 1 && i.day === start_time.date())

          const row = {
            index: i++,
            time: start_time.format('DD/MM/YYYY'),
            event: spike_day ? spike_day.name : '',
            target_gmv: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_gmv : flash_sale_gmv2) : avg_gmv_after,
            target_gmv_ads: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_gmv_ads : flash_sale_gmv_ads2) : avg_gmv_ads_after,
            target_cost: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_cost : flash_sale_cost2) : avg_cost_after,
            target_aov: 0,
            target_order: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_order : flash_sale_order2) : avg_order_after,
            target_traffic: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_traffic : flash_sale_traffic2) : avg_traffic_after,
            target_cr: 0,
            aov: 0,
            order: 0,
            traffic: 0,
            cr: 0,
            gmv: 0,
            gmv_ads: 0,
            editable: false,
            editable1: false,
            editable2: false,
            editable3: false,
            editable4: false
          }

          if (row.target_order) {
            row.target_aov = Math.floor(row.target_gmv_ads / row.target_order)
          }

          if (row.target_traffic) {
            row.target_cr = +(row.target_order * 100 / row.target_traffic).toFixed(2)
          }

          product.data.push(row)

          start_time = start_time.add(1, 'day')
        }
      }

      this.data_product = _orderBy(data, ['target_gmv', 'target_cost', 'target_traffic'], ['desc', 'desc', 'desc'])
    },

    async m__get_spike_days() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/shopee/spike_days', this.cf())
      this.spike_days = resp.body.data
    },

    async m__send_request_list() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/send_request_list', this.cf())
      this.send_request_list = resp.body.data
    },

    async export_file_excel() {
      if (!this.shopee_shop.selected || !this.data || !this.data.length) {
        return
      }

      const data = [
        ['Ngày', 'Event Shopee', 'Số liệu tham khảo', '', '', '', '', '', 'Kế hoạch'],
        ['', '', 'GMV', 'GMV Ads', 'AOV', 'Order', 'Traffic', 'CR', 'Target GMV', 'Target GMV Ads', 'Chi phí Ads', 'AOV', 'Order', 'Traffic', 'CR'],
        [''],
        ['']
      ]

      for (const item of this.data) {
        const row = [item.time, item.event, item.gmv, item.gmv_ads, item.aov, item.order, item.traffic, item.cr, item.target_gmv, item.target_gmv_ads, item.target_cost, item.target_aov, item.target_order, item.target_traffic, item.target_cr]
        data.push(row)
      }

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        data: data,
        filename: `file-ke-hoach-agency-thang-${this.month + 1}-${this.year}.xlsx`
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `file-ke-hoach-agency-thang-${this.month + 1}-${this.year}.xlsx`)
      document.body.appendChild(link)
      link.click()
    },

    async m__get_combo_cost() {
      try {
        // const start_time = this.dayjs([this.year, this.month]).startOf('month')
        // const end_time = this.month >= this.dayjs().month() ? this.dayjs().startOf('d') : this.dayjs([this.year, this.month]).endOf('month').add(1, 'second')
        const start_time = this.m__init_start_time()
        const end_time = this.m__init_end_time(true)

        const metrics_resp = await this.seller.marketing_get_bundle_deal_metrics(start_time.unix(), end_time.unix(), this.time_type)
        if (metrics_resp && metrics_resp.data && metrics_resp.data.result) {
          this.gmv_combo = Math.floor(metrics_resp.data.result.sales.value)
          this.aov_combo = Math.floor(metrics_resp.data.result.sales_per_buyer.value)
          this.order_combo = Math.floor(metrics_resp.data.result.orders.value)
          this.traffic_combo = Math.floor(metrics_resp.data.result.buyers.value)
          this.cr_combo = +this.traffic_combo ? +(this.order_combo * 100 / this.traffic_combo).toFixed(2) : 0
        }

        let total = 0
        const resp = await this.seller.marketing_get_bundle_deal(start_time.subtract(1, 'second').unix(), end_time.unix(), this.time_type)
        if (resp.data && resp.data.data && resp.data.data.hits) {
          for (const item of resp.data.data.hits) {
            let order_list = [], offset = 0, limit = 60
            let order_resp = await this.seller.marketing_get_bundle_deal_order(item.bundle_deal_id, offset, limit)
            while (order_resp && order_resp.data && order_resp.data.data && order_resp.data.data.order_with_items &&
            order_resp.data.data.order_with_items.length) {
              order_list.push(...order_resp.data.data.order_with_items)
              offset += limit
              order_resp = await this.seller.marketing_get_bundle_deal_order(item.bundle_deal_id, offset, limit)
            }

            for (const order of order_list) {
              total += order.order_items.reduce((t, i) => {
                const st = i.bundle_deal_item_list.reduce((sst, ii) => {
                  return sst + (+ii.item_price * ii.amount)
                }, 0)
                return t + (st - +i.order_price)
              }, 0)
            }
          }
        }

        console.log('cost combo: ', total)
        this.cost_combo = total
      } catch (e) {
        console.error(`Combo error: ${e}`)
      }
    },

    async m__get_voucher_cost() {
      try {
        // const start_time = this.dayjs([this.year, this.month]).startOf('month')
        // const end_time = this.month >= this.dayjs().month() ? this.dayjs().startOf('d') : this.dayjs([this.year, this.month]).endOf('month').add(1, 'second')
        const start_time = this.m__init_start_time()
        const end_time = this.m__init_end_time(true)

        const metrics_resp = await this.seller.marketing_get_voucher_metrics(start_time.unix(), end_time.unix(), this.time_type)
        if (metrics_resp && metrics_resp.data && metrics_resp.data.result) {
          this.gmv_voucher = Math.floor(metrics_resp.data.result.sales.value)
          // this.aov_voucher = Math.floor(metrics_resp.data.result.sales_per_buyer.value)
          this.aov_voucher = +metrics_resp.data.result.orders.value ? Math.floor(+metrics_resp.data.result.sales.value / +metrics_resp.data.result.orders.value) : 0
          // this.order_voucher = Math.floor(metrics_resp.data.result.units.value)
          this.order_voucher = Math.floor(metrics_resp.data.result.orders.value)
          // this.traffic_voucher = Math.floor(metrics_resp.data.result.used.value)
          this.traffic_voucher = +(metrics_resp.data.result.usage_rate.value).toFixed(2) + '%'
          this.cr_voucher = '-'

          console.log('cost voucher:', metrics_resp.data.result.cost.value)
          this.cost_voucher = Math.floor(metrics_resp.data.result.cost.value)
        }
      } catch (e) {
        console.error(`Voucher error: ${e}`)
      }
    },

    async m__get_flash_sale_cost() {
      try {
        // const start_time = this.dayjs([this.year, this.month]).startOf('month')
        // const end_time = this.month >= this.dayjs().month() ? this.dayjs().startOf('d') : this.dayjs([this.year, this.month]).endOf('month').add(1, 'second')
        const start_time = this.m__init_start_time()
        const end_time = this.m__init_end_time(true)

        const metrics_resp = await this.seller.marketing_get_flash_sale_metrics(start_time.unix(), end_time.unix(), this.time_type)
        if (metrics_resp && metrics_resp.data && metrics_resp.data.result) {
          this.gmv_flash_sale = Math.floor(metrics_resp.data.result.sales.value)
          this.aov_flash_sale = Math.floor(metrics_resp.data.result.sales_per_buyer.value)
          this.order_flash_sale = Math.floor(metrics_resp.data.result.orders.value)
          this.traffic_flash_sale = Math.floor(metrics_resp.data.result.reminder_clicks.value)
          this.cr_flash_sale = +this.traffic_flash_sale ? +(this.order_flash_sale * 100 / this.traffic_flash_sale).toFixed(2) : 0
        }

        let flash_sale_list = [], offset = 0, limit = 20
        let fs_resp = await this.seller.flash_sale_get_list(offset, limit, 0, start_time.unix(), end_time.unix())
        while (fs_resp.data.flash_sale_list && fs_resp.data.flash_sale_list.length > 0) {
          if (this.is_destroyed) return

          flash_sale_list.push(...fs_resp.data.flash_sale_list)
          offset += limit
          fs_resp = await this.seller.flash_sale_get_list(offset, limit, 0, start_time.unix(), end_time.unix())
        }

        let item_ids = [], ranking_list = []

        flash_sale_list = flash_sale_list.filter(i => +i.item_count > 0)
        for (const fs of flash_sale_list) {
          if (this.is_destroyed) return

          const ranking_resp = await this.seller.flash_sale_get_product_ranking(fs.flash_sale_id)
          if (ranking_resp && ranking_resp.result) {
            ranking_list.push(...ranking_resp.result)
            item_ids.push(...ranking_resp.data.map(i => i.item_id))
            await this.sleep(1000)
          }
        }

        const product_list = []
        let page_index = 1
        let products_resp = await this.seller.get_product_by_page(page_index)
        while (products_resp.length) {
          for (const item of products_resp) {
            item.price = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.promotion_price : 0
            item.price_before_discount = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.normal_price : 0
          }

          product_list.push(...products_resp)
          products_resp = await this.seller.get_product_by_page(page_index + 1)
          page_index++
        }

        // console.log(product_list)
        let total = 0
        for (const item of ranking_list) {
          const product_found = product_list.find(i => i.id === item.item_id)
          for (const model of item.models) {
            const model_found = product_found ? product_found.model_list.find(i => i.id === model.model_id) : null
            if (model_found) {
              total = total + ((+model_found.price_info.promotion_price - model.discount_price) * model.units)
            }
          }
        }

        // const product_resp = await this.seller.get_product_by_ids(_uniq(item_ids))
        // // console.log(ranking_list)
        // // console.log(product_resp)
        // if (product_resp.data && product_resp.data.data && product_resp.data.data.list) {
        //   for (const item of ranking_list) {
        //     if (this.is_destroyed) return
        //
        //     const product_found = product_resp.data.data.list.find(i => i.id === item.item_id)
        //     for (const model of item.models) {
        //       const model_found = product_found ? product_found.model_list.find(i => i.id === model.model_id) : null
        //       if (model_found) {
        //         total = total + ((+model_found.price - model.discount_price) * model.units)
        //       }
        //     }
        //   }
        // }

        console.log('cost flash sale:', total)
        this.cost_flash_sale = total
      } catch (e) {
        console.error(`Flash sale error: ${e}`)
      }
    },

    m__use_aov() {
      if (+this.aov) {
        for (const item of this.data_target) {
          item.aov = this.aov
          if (+item.aov) item.order = Math.floor(item.gmv / item.aov)
          if (+item.cr) item.traffic = Math.floor(+item.order * 100 / +item.cr)
        }
      }
    },

    m__use_cr() {
      if (+this.cr) {
        for (const item of this.data_target) {
          item.cr = this.cr
          if (+item.cr) item.traffic = Math.floor(+item.order * 100 / +item.cr)
        }
      }
    },

    m__on_change_target_plan(key, row) {
      if (key === 'gmv') {
        row.gmv = +this.expected_gmv ? row.gmv_percent * this.expected_gmv / 100 : 0
      }
      if (key === 'cost') {
        row.cost = +this.expected_cost ? row.cost_percent * this.expected_cost / 100 : 0
      }

      if (!row.parent) {
        for (const child of this.data_target.filter(i => i.parent === row.type)) {
          this.m__on_change(key, child)
        }
      }

      if (key === 'gmv' || key === 'aov') {
        for (const item of this.data_target) {
          if (+item.aov) item.order = Math.floor(item.gmv / item.aov)
          if (+item.cr) item.traffic = Math.floor(+item.order * 100 / +item.cr)
        }
      }

      if (key === 'cr') {
        if (+row.cr) row.traffic = Math.floor(+row.order * 100 / +row.cr)
      }
    },

    async m__use_agency_file(file) {
      file.loading = true
      try {
        if (this.shopee_shop.list.find(i => i._id === file.shopId)) {
          this.month = file.month
          this.year = file.year
          this.expected_month = file.expectedMonth
          this.expected_gmv = file.expectedGmv
          this.expected_gmv_ads = file.expectedGmvAds
          this.expected_cost = file.expectedCost
          this.shopee_shop.selected = file.shopId
          // await this.m__initial_view()
          this.data = JSON.parse(file.data)
          this.data_product = file.dataProduct ? JSON.parse(file.dataProduct) : []
          this.data_target = file.dataTarget ? JSON.parse(file.dataTarget) : []

          if (!this.data_target) {
            this.data_target = []
            const headers = []
            const extend = ['Shopee Ads', 'Facebook Ads', 'Booking Group', 'Voucher Tung Group', 'Voucher Shop', 'Gift', 'Tiktok', 'Shopee Live', 'Book KOL/KOC']
            const spike_day = 4
            for (const item of extend) {
              headers.push({
                name: item,
                type: item,
                parent: ''
              })
              for (let i = 1; i <= spike_day; i++) {
                headers.push({
                  name: `Spike day ${i}`,
                  type: item,
                  parent: item
                })
              }
              headers.push({
                name: 'Khác',
                type: item,
                parent: item
              })
            }
            const key = {
              gmv_percent: 0,
              gmv: null,
              cost_percent: 0,
              cost: null,
              order: null,
              cr: null,
              aov: null,
              traffic: null
            }
            for (const item of headers) {
              Object.assign(item, key)
            }
            this.data_target.push(...headers)
          }

          this.m__generate_scrollbar()

          this.show_dialog.agency_file = false
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        file.loading = false
      }
    },

    m__get_shop_name(file) {
      const shop_found = this.shopee_shop.list.find(i => i._id === file.shopId)
      return shop_found ? shop_found.username : ''
    },

    async m__delete_agency_file(file) {
      try {
        await this.$confirm('Bạn có muốn xoá file agency này không?', this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })

        await this.$http.delete(this.API.URL_API_SRV_1 + '/agency_file', {
          ...this.cf(),
          params: {
            fileId: file.id,
            mipeeUserId: this.$store.state.userInfo.username
          }
        })
        await this.m__get_agency_file()
        this.ntf_s('Xoá file thành công')
      } catch (e) {
      }
    },

    async m__get_agency_file() {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/all', {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file', {
      const mipeeUserIds = [this.$store.state.userInfo.username, ...this.send_request_list.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds
        }
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(ii => ii._id === i.shopId))
    },

    m__show_agency_file_dialog() {
      this.show_dialog.agency_file = true
    },

    m__on_change_target_cost(row) {
      const other_list = this.divided === '1'
        ? this.data.filter(i => i.time !== row.time && !i.event)
        : this.data.filter(i => i.time !== row.time)
      if (other_list.length === 0) return

      const total_other_list = other_list.reduce((total, item) => total + +item.target_cost, 0)
      let remaining_of_remaining = Math.floor(total_other_list / other_list.length)
      for (const item of other_list) {
        item.target_cost = remaining_of_remaining
      }

      let total_target_cost = this.data.reduce((total, item) => total + +item.target_cost, 0)
      let remaining_cost = this.expected_cost ? +this.expected_cost - total_target_cost : 0
      remaining_of_remaining = Math.floor(remaining_cost / other_list.length)
      for (const item of other_list) {
        item.target_cost = +item.target_cost + remaining_of_remaining
      }

      total_target_cost = this.data.reduce((total, item) => total + +item.target_cost, 0)
      remaining_cost = this.expected_cost ? this.expected_cost - total_target_cost : 0
      const not_event = this.data.find(i => !i.event && i.time !== row.time)
      if (not_event) not_event.target_cost = +not_event.target_cost + remaining_cost
    },

    m__on_change_target_gmv(row) {
      const other_list = this.divided === '1'
        ? this.data.filter(i => i.time !== row.time && !i.event)
        : this.data.filter(i => i.time !== row.time)
      if (other_list.length === 0) return

      const total_other_list = other_list.reduce((total, item) => total + +item.target_gmv, 0)
      let remaining_of_remaining = Math.floor(total_other_list / other_list.length)
      for (const item of other_list) {
        item.target_gmv = remaining_of_remaining
        this.m__on_change(item, 'gmv')
      }

      let total_target_gmv = this.data.reduce((total, item) => total + +item.target_gmv, 0)
      let remaining_gmv = this.expected_gmv ? +this.expected_gmv - total_target_gmv : 0
      remaining_of_remaining = Math.floor(remaining_gmv / other_list.length)
      for (const item of other_list) {
        item.target_gmv = +item.target_gmv + remaining_of_remaining
        this.m__on_change(item, 'gmv')
      }

      total_target_gmv = +this.data.reduce((total, item) => total + +item.target_gmv, 0)
      remaining_gmv = this.expected_gmv ? this.expected_gmv - total_target_gmv : 0
      const not_event = this.data.find(i => !i.event && i.time !== row.time)
      if (not_event) not_event.target_gmv = +not_event.target_gmv + remaining_gmv

      this.m__on_change(row, 'gmv')
    },

    m__on_change_target_gmv_ads(row) {
      const other_list = this.divided === '1'
        ? this.data.filter(i => i.time !== row.time && !i.event)
        : this.data.filter(i => i.time !== row.time)
      if (other_list.length === 0) return

      const total_other_list = other_list.reduce((total, item) => total + +item.target_gmv_ads, 0)
      let remaining_of_remaining = Math.floor(total_other_list / other_list.length)
      for (const item of other_list) {
        item.target_gmv_ads = remaining_of_remaining
      }

      let total_target_gmv_ads = +this.data.reduce((total, item) => total + +item.target_gmv_ads, 0)
      let remaining_gmv_ads = this.expected_gmv_ads ? +this.expected_gmv_ads - total_target_gmv_ads : 0
      remaining_of_remaining = Math.floor(remaining_gmv_ads / other_list.length)
      for (const item of other_list) {
        item.target_gmv_ads = +item.target_gmv_ads + remaining_of_remaining
      }

      total_target_gmv_ads = +this.data.reduce((total, item) => total + +item.target_gmv_ads, 0)
      remaining_gmv_ads = this.expected_gmv_ads ? this.expected_gmv_ads - total_target_gmv_ads : 0
      const not_event = this.data.find(i => !i.event && i.time !== row.time)
      if (not_event) not_event.target_gmv_ads = +not_event.target_gmv_ads + remaining_gmv_ads
    },

    m__cell_class_name({row}) {
      if (!row.parent) {
        return 'parent-row no-hover'
      }

      return 'no-hover'
    },

    m__header_style({column}) {
      if (['Kế hoạch', 'GMV', 'Target GMV', 'Tùy chọn'].includes(column.label) || column.label.includes('Số liệu tham khảo')) {
        return 'cell-style'
      }
    },

    m__cell_style({column}) {
      if (['gmv', 'target_gmv', 'Tùy chọn'].includes(column.property)) {
        return 'cell-style'
      }
    },

    m__show_agency_filename_dialog() {
      if (!this.data.length) {
        return
      }

      this.filename = `${this.shop.username} - Kế hoạch chi tiết Tháng ${this.expected_month + 1}/${this.dayjs().year()} - ${this.dayjs().format('DDMMHHmm')}`
      this.show_dialog.create_agency_filename = true
    },

    async m__save_agency_file() {
      if (!this.data.length) {
        return
      }

      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
      }

      this.loading.save_file = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/agency_file', {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shopee_shop.selected,
          filename: this.filename,
          month: this.month,
          year: this.year,
          expectedMonth: this.expected_month,
          expectedGmv: this.expected_gmv,
          expectedGmvAds: this.expected_gmv_ads,
          expectedCost: this.expected_cost,
          expectedType: this.expected_cost_type,
          data: JSON.stringify(this.data),
          dataProduct: JSON.stringify(this.data_product),
          dataTarget: JSON.stringify(this.data_target)
        }, this.cf())
        await this.m__get_agency_file()

        this.show_dialog.create_agency_filename = false
        this.ntf_s('Tạo file thành công')
        this.counter++
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.save_file = false
      }
    },

    m__show_update_column_dialog() {
      this.show_dialog.update_column = true
    },

    m__confirm_update_column() {
      if (!this.form_update[`${this.form_update.value}_value`]) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      for (const item of this.data) {
        if (this.form_update[`${this.form_update.value}_type`] === 'inc') {
          item[`target_${this.form_update.value}`] += +this.form_update[`${this.form_update.value}_value`]
        }
        if (this.form_update[`${this.form_update.value}_type`] === 'des') {
          item[`target_${this.form_update.value}`] -= +this.form_update[`${this.form_update.value}_value`]
        }
        if (this.form_update[`${this.form_update.value}_type`] === 'inc_percent') {
          const percent = item[`target_${this.form_update.value}`] ? Math.floor(this.form_update[`${this.form_update.value}_value`] * 100 / item[`target_${this.copy_column}`]) : 0
          item[`target_${this.form_update.value}`] += percent
        }
        if (this.form_update[`${this.form_update.value}_type`] === 'desc_percent') {
          const percent = item[`target_${this.form_update.value}`] ? Math.floor(this.form_update[`${this.form_update.value}_value`] * 100 / item[`target_${this.copy_column}`]) : 0
          item[`target_${this.form_update.value}`] -= percent
        }
        if (this.form_update[`${this.form_update.value}_type`] === 'cost') {
          item[`target_${this.form_update.value}`] = +this.form_update[`${this.form_update.value}_value`]
        }

        this.m__on_change(item, this.form_update.value)
      }

      this.show_dialog.update_column = false
    },

    m__show_copy_column_dialog() {
      this.show_dialog.copy_column = true
    },

    m__confirm_copy_column() {
      for (const item of this.data) {
        item[`target_${this.copy_column}`] = item[this.copy_column]
        this.m__on_change(item, this.copy_column)
        // for (const key of Object.keys(this.copy_columns)) {
        //   if (this.copy_columns[key].checked) {
        //     item[`target_${key}`] = item[key]
        //     this.m__on_change(item, key)
        //   }
        // }
      }
      this.show_dialog.copy_column = false
    },

    m__on_change(row, key) {
      if (key === 'gmv') {
        row.target_order = +row.target_aov ? Math.floor(row.target_gmv / row.target_aov) : 0
        row.target_cr = +row.target_traffic ? +(row.target_order * 100 / row.target_traffic).toFixed(2) : 0
      }

      if (key === 'aov') {
        row.target_order = +row.target_aov ? Math.floor(row.target_gmv / row.target_aov) : 0
        row.target_cr = +row.target_traffic ? +(row.target_order * 100 / row.target_traffic).toFixed(2) : 0
      }

      if (key === 'order') {
        row.target_aov = +row.target_order ? Math.floor(row.target_gmv / row.target_order) : 0
        row.target_cr = +row.target_traffic ? +(row.target_order * 100 / row.target_traffic).toFixed(2) : 0
      }

      if (key === 'traffic') {
        row.target_cr = +row.target_traffic ? +(row.target_order * 100 / row.target_traffic).toFixed(2) : 0
      }

      if (key === 'cr') {
        // row.target_traffic = +row.target_cr ? +(row.target_order / row.target_cr).toFixed(2) : 0
        row.target_traffic = +row.target_cr ? Math.floor(+row.target_order * 100 / +row.target_cr) : 0
      }
    },

    m__calculate_expected_cost() {
      if (!this.expected_cost) {
        return 0
      }

      if (this.expected_cost_type === 'cost') {
        return this.expected_cost
      } else {
        return this.expected_gmv * this.expected_cost / 100
      }
    },

    m__generate_scrollbar() {
      this.$nextTick(() => {
        try {
          const dashboard_wrapper = document.getElementById('dashboard-wrapper')
          const main_pagination = document.getElementById('main-pagination')

          const main_table = document.querySelector('div#main-table-plan')
          const main_table_fixed = document.querySelector('div#main-table-plan-fixed')
          const main_table_wrapper = document.querySelector('div#main-table-plan div.el-table__body-wrapper')
          const main_table_wrapper_fixed = document.querySelector('div#main-table-plan-fixed div.el-table__header-wrapper')
          const scrollbar = document.getElementById('double-scroll-bar')

          const scrollbar_wrapper = document.getElementById('double-scroll-wrapper')
          scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
          main_table_fixed.style.width = main_table.scrollWidth + 'px'

          scrollbar.appendChild(document.createElement('div'))
          scrollbar.style.overflow = 'auto'
          scrollbar.style.overflowY = 'hidden'
          scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          this.interval = setInterval(() => {
            scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
            main_table_fixed.style.width = main_table.scrollWidth + 'px'
            scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          }, 1000)
          scrollbar.firstChild.style.paddingTop = '1px'
          scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
          scrollbar.onscroll = () => {
            main_table_wrapper.scrollLeft = scrollbar.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }
          main_table_wrapper.onscroll = () => {
            scrollbar.scrollLeft = main_table_wrapper.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }

          const bounding_main_pagination = () => {
            const rect = main_pagination.getBoundingClientRect()
            const elem_top = rect.top
            const is_visible = elem_top <= window.innerHeight
            if (is_visible) {
              scrollbar_wrapper.style.zIndex = '-1'
            } else {
              scrollbar_wrapper.style.zIndex = '2000'
            }

            const rect2 = main_table_wrapper.getBoundingClientRect()
            const elem_top2 = rect2.top
            const elem_bot2 = rect2.bottom
            if (elem_top2 > 0 || elem_bot2 <= 100) {
              main_table_fixed.style.zIndex = '-1'
            } else {
              main_table_fixed.style.zIndex = '2000'
            }
          }
          bounding_main_pagination()

          dashboard_wrapper.onscroll = () => {
            bounding_main_pagination()
          }
        } catch (e) {
        }
      })
    },

    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            await this.m__get_metrics()
            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      }
    },

    async m__get_metrics() {
      this.loading.get_metrics = true

      Object.assign(this, {
        aov: 0,
        aov_ads: 0,
        order: 0,
        order_ads: 0,
        traffic: 0,
        traffic_ads: 0,
        cr: 0,
        cr_ads: 0,
        gmv: 0,
        gmv_ads: 0,
        cost_ads: 0,
        cost_combo: 0,
        cost_voucher: 0,
        cost_flash_sale: 0
      })

      const select_month = document.getElementById('select-month')
      if (this.month === null && select_month) {
        this.$nextTick(() => {
          select_month.focus()
        })
      }

      if (!this.shopee_shop.selected || this.month === null || this.year === null) {
        this.loading.get_metrics = false
        return
      }

      try {
        // const start_time = this.dayjs([this.year, this.month]).startOf('month')
        // const end_time = this.dayjs([this.year, this.month]).endOf('month')
        const start_time = this.m__init_start_time()
        const end_time = this.m__init_end_time()
        const resp = await this.seller.marketing_homepage_report_by_time(start_time.toDate(), end_time.toDate(), '[0,1,2,3,4,5,8]')
        if (!resp || !resp.data || !resp.data.data) {
          this.metrics_ads = {}
          this.aov = this.order = this.traffic = this.cr = null
          return
        }

        const metrics_ads = {}
        for (const item of resp.data.data.homepage_report) {
          for (const key of Object.keys(item)) {
            if (metrics_ads[key]) {
              metrics_ads[key] += +item[key]
            } else {
              metrics_ads[key] = +item[key]
            }
          }
        }
        this.metrics_ads = metrics_ads
        this.reports = resp.data.data.homepage_report

        const end_time_clone = end_time.isSameOrAfter(this.dayjs(), 'd') ? this.dayjs().startOf('d') : end_time.clone().add(1, 'd').startOf('d')
        const metrics_resp = await this.seller.dashboard__key_metrics(start_time.unix(), end_time_clone.unix(), this.time_type)
        const key_metrics = this.key_metrics = metrics_resp.result

        this.aov = Math.floor(key_metrics.confirmed_sales_per_order.value)
        this.order = +key_metrics.confirmed_orders.value
        this.traffic = +key_metrics.shop_uv.value
        this.cr = +key_metrics.shop_uv.value ? +(this.order * 100 / this.traffic).toFixed(2) : 0.00
        this.gmv = +key_metrics.confirmed_gmv.value

        this.gmv_ads = Math.floor(metrics_ads.broad_gmv)
        this.cost_ads = Math.floor(metrics_ads.cost)
        this.aov_ads = metrics_ads.order_amount > 0 ? Math.floor(metrics_ads.broad_gmv / metrics_ads.order_amount) : 0
        this.order_ads = Math.floor(metrics_ads.order_amount)
        this.traffic_ads = Math.floor(metrics_ads.click)
        this.cr_ads = metrics_ads.click > 0 ? +(metrics_ads.order_amount * 100 / metrics_ads.click).toFixed(2) : 0.00
      } catch (e) {
        console.error(e)
      }

      await Promise.all([
        this.m__get_combo_cost(),
        this.m__get_voucher_cost(),
        this.m__get_flash_sale_cost()
      ])

      this.loading.get_metrics = false
    },

    m__generate_first_of_data() {
      const row = {
        is_first: true,
        time: '',
        event: '',
        index: '',
        target_gmv: 0,
        target_cost: 0,
        target_aov: null,
        target_order: null,
        target_traffic: null,
        target_cr: null,
        editable: false
      }

      const total_target_gmv = +this.data.reduce((total, item) => total + +item.target_gmv, 0)
      const total_target_gmv_ads = +this.data.reduce((total, item) => total + +item.target_gmv_ads, 0)
      const total_target_cost = +this.data.reduce((total, item) => total + +item.target_cost, 0)
      row.target_gmv = this.expected_gmv ? this.expected_gmv - total_target_gmv : 0
      row.target_gmv_ads = this.expected_gmv_ads ? this.expected_gmv_ads - total_target_gmv_ads : 0
      row.target_cost = this.expected_cost ? this.expected_cost - total_target_cost : 0

      row.gmv = '-'
      row.gmds = '-'
      row.aov = '-'
      row.order = '-'
      row.traffic = '-'
      row.cr = '-'
      // row.aov = Math.floor(this.key_metrics.confirmed_sales_per_order.value)
      // row.order = +this.key_metrics.confirmed_orders.value
      // row.traffic = +this.key_metrics.shop_uv.value
      // row.gmv = +this.data.reduce((total, item) => total + +item.gmv, 0)
      // row.gmv_ads = +this.data.reduce((total, item) => total + +item.gmv_ads, 0)
      // row.aov = this.aov
      // row.order = this.order
      // row.traffic = this.traffic
      // row.cr = row.traffic > 0 ? +(row.order * 100 / row.traffic).toFixed(2) : 0.00
      // row.aov = this.metrics_ads.order_amount > 0 ? Math.floor(this.metrics_ads.broad_gmv / this.metrics_ads.order_amount) : 0
      // row.order = Math.floor(this.metrics_ads.order_amount)
      // row.traffic = Math.floor(this.metrics_ads.click)
      // row.cr = this.metrics_ads.click > 0 ? +(this.metrics_ads.order_amount / this.metrics_ads.click * 100).toFixed(2) : 0.00

      return row
    },

    async m__generate_expected() {
      if (!this.shopee_shop.selected || this.month === null) {
        return
      }

      if (this.expected_month === null) {
        this.ntf_w('Vui lòng chọn tháng')
        return
      }

      if (this.expected_cost_type === 'percent') {
        this.expected_cost = Math.floor(this.expected_gmv * this.expected_cost / 100)
        this.expected_cost_type = 'cost'
      }

      try {
        try {
          if (this.data.length) {
            await this.$confirm(`Bạn có muốn tạo lại dữ liệu không?`, this.$t('base.attention'), {
              type: 'warning',
              confirmButtonText: this.$t('base.confirm'),
              cancelButtonText: this.$t('base.cancel')
            })
          }
        } catch (e) {
          return
        }

        this.loading.generate_data = true
        this.data = []

        let start_time = this.dayjs([this.dayjs().year(), this.expected_month]).startOf('month')
        const end_time = this.dayjs([this.dayjs().year(), this.expected_month]).endOf('month')

        const reports = []
        const resp = await this.seller.marketing_homepage_report_by_time(start_time.toDate(), end_time.toDate(), '[0,1,2,3,4,5,8]')
        if (resp && resp.data && resp.data.data && resp.data.data.homepage_report) {
          reports.push(...resp.data.data.homepage_report)
        }

        // const avg_gmv = Math.floor(this.expected_gmv / end_time.date())
        // const flash_sale_gmv = avg_gmv * 2
        // const avg_gmv_after = Math.floor((this.expected_gmv - flash_sale_gmv) / (end_time.date() - 1))
        //
        // const avg_gmv_ads = Math.floor(this.expected_gmv_ads / end_time.date())
        // const flash_sale_gmv_ads = avg_gmv_ads * 2
        // const avg_gmv_ads_after = Math.floor((this.expected_gmv_ads - flash_sale_gmv_ads) / (end_time.date() - 1))
        //
        // const avg_cost = Math.floor(this.m__calculate_expected_cost() / end_time.date())
        // const flash_sale_cost = avg_cost * 2
        // const avg_cost_after = Math.floor((this.m__calculate_expected_cost() - flash_sale_cost) / (end_time.date() - 1))

        // const avg_gmv = Math.floor(this.expected_gmv / end_time.date())
        const flash_sale_gmv = Math.floor(this.expected_gmv * 25 / 100)
        const flash_sale_gmv2 = Math.floor(this.expected_gmv * 10 / 100)
        const avg_gmv_after = Math.floor((this.expected_gmv - (flash_sale_gmv + flash_sale_gmv2)) / (end_time.date() - 2))

        const flash_sale_gmv_ads = Math.floor(this.expected_gmv_ads * 25 / 100)
        const flash_sale_gmv_ads2 = Math.floor(this.expected_gmv_ads * 10 / 100)
        const avg_gmv_ads_after = Math.floor((this.expected_gmv_ads - (flash_sale_gmv_ads + flash_sale_gmv_ads2)) / (end_time.date() - 2))

        const flash_sale_cost = Math.floor(this.m__calculate_expected_cost() * 25 / 100)
        const flash_sale_cost2 = Math.floor(this.m__calculate_expected_cost() * 10 / 100)
        const avg_cost_after = Math.floor((this.m__calculate_expected_cost() - (flash_sale_cost + flash_sale_cost2)) / (end_time.date() - 2))

        let i = 1
        while (start_time.isSameOrBefore(end_time, 'd')) {
          const spike_day = this.spike_days.find(i => i.month === start_time.month() + 1 && i.day === start_time.date())

          const row = {
            index: i++,
            time: start_time.format('DD/MM/YYYY'),
            // event: start_time.date() === start_time.month() + 1 ? `Flash Sale ${start_time.date()}/${start_time.month() + 1}` : '',
            // target_gmv: start_time.date() === start_time.month() + 1 ? flash_sale_gmv : avg_gmv_after,
            // target_gmv_ads: start_time.date() === start_time.month() + 1 ? flash_sale_gmv_ads : avg_gmv_ads_after,
            // target_cost: start_time.date() === start_time.month() + 1 ? flash_sale_cost : avg_cost_after,
            event: spike_day ? spike_day.name : '',
            target_gmv: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_gmv : flash_sale_gmv2) : avg_gmv_after,
            target_gmv_ads: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_gmv_ads : flash_sale_gmv_ads2) : avg_gmv_ads_after,
            target_cost: spike_day ? (spike_day.type === 'spike_day' ? flash_sale_cost : flash_sale_cost2) : avg_cost_after,
            target_aov: 0,
            target_order: 0,
            target_traffic: 0,
            target_cr: 0,
            aov: 0,
            order: 0,
            traffic: 0,
            cr: 0,
            gmv: 0,
            gmv_ads: 0,
            editable: false,
            editable1: false,
            editable2: false,
            editable3: false,
            editable4: false
          }

          const timestamp = this.dayjs([this.year, this.month, start_time.date()]).unix()
          row.aov = this.key_metrics.confirmed_sales_per_order.points && this.key_metrics.confirmed_sales_per_order.points.find(i => i.timestamp === timestamp)
            ? +this.key_metrics.confirmed_sales_per_order.points.find(i => i.timestamp === timestamp).value
            : 0
          row.order = this.key_metrics.confirmed_orders.points && this.key_metrics.confirmed_orders.points.find(i => i.timestamp === timestamp)
            ? +this.key_metrics.confirmed_orders.points.find(i => i.timestamp === timestamp).value
            : 0
          row.traffic = this.key_metrics.shop_uv.points && this.key_metrics.shop_uv.points.find(i => i.timestamp === timestamp)
            ? +this.key_metrics.shop_uv.points.find(i => i.timestamp === timestamp).value
            : 0
          row.cr = row.traffic > 0 ? +(row.order * 100 / row.traffic).toFixed(2) : 0.00
          row.gmv = this.key_metrics.confirmed_gmv.points && this.key_metrics.confirmed_gmv.points.find(i => i.timestamp === timestamp)
            ? +this.key_metrics.confirmed_gmv.points.find(i => i.timestamp === timestamp).value
            : 0

          const metric_ads_found = this.reports.find(i => i.timestamp === timestamp)
          if (metric_ads_found) {
            row.gmv_ads = metric_ads_found.broad_gmv
          }
          // const metric_ads_found = this.reports.find(i => i.timestamp === timestamp)
          // if (metric_ads_found) {
          //   row.aov = metric_ads_found.order_amount > 0 ? Math.floor(metric_ads_found.broad_gmv / metric_ads_found.order_amount) : 0
          //   row.order = Math.floor(metric_ads_found.order_amount)
          //   row.traffic = Math.floor(metric_ads_found.click)
          //   row.cr = metric_ads_found.click > 0 ? +(metric_ads_found.order_amount / metric_ads_found.click * 100).toFixed(2) : 0.00
          // }

          // const report_found = reports.find(i => i.timestamp === start_time.unix())
          // if (report_found && !start_time.isSameOrAfter(this.dayjs(), 'd'))
          // if (report_found && !start_time.isAfter(this.dayjs(), 'd')) {
          //   row.editable = false
          //   row.target_gmv = Math.floor(report_found.broad_gmv)
          //   row.target_cost = Math.floor(report_found.cost)
          //   row.target_aov = report_found.order_amount > 0 ? Math.floor(report_found.broad_gmv / report_found.order_amount) : 0
          //   row.target_order = Math.floor(report_found.order_amount)
          //   row.target_traffic = Math.floor(report_found.click)
          //   row.target_cr = report_found.click > 0 ? +(report_found.order_amount / report_found.click * 100).toFixed(2) : 0.00
          // } else {
          //   const total_target_gmv = this.data.reduce((total, item) => {
          //     if (!item.editable) total += item.target_gmv
          //     return total
          //   }, 0)
          //   const total_target_cost = this.data.reduce((total, item) => {
          //     if (!item.editable) total += item.target_cost
          //     return total
          //   }, 0)
          //   row.target_gmv = this.expected_gmv ? this.expected_gmv - total_target_gmv : 0
          //   row.target_cost = this.expected_cost ? this.expected_cost - total_target_cost : 0
          //   row.target_aov = 0
          //   row.target_order = 0
          //   row.target_traffic = 0
          //   row.target_cr = 0
          // }

          start_time = start_time.add(1, 'day')
          this.data.push(row)
        }

        if (this.data.length) {
          const total_target_gmv = +this.data.reduce((total, item) => total + +item.target_gmv, 0)
          if (this.expected_gmv - total_target_gmv > 0) {
            const event_found = this.data.find(i => i.event)
            if (event_found) event_found.target_gmv += (this.expected_gmv - total_target_gmv)
          }

          const total_target_gmv_ads = +this.data.reduce((total, item) => total + +item.target_gmv_ads, 0)
          if (this.expected_gmv_ads - total_target_gmv_ads > 0) {
            const event_found = this.data.find(i => i.event)
            if (event_found) event_found.target_gmv_ads += (this.expected_gmv_ads - total_target_gmv_ads)
          }

          const total_target_cost = +this.data.reduce((total, item) => total + +item.target_cost, 0)
          if (this.expected_cost - total_target_cost > 0) {
            const event_found = this.data.find(i => i.event)
            if (event_found) event_found.target_cost += (this.expected_cost - total_target_cost)
          }
        }

        this.data_target = []
        const headers = []
        const extend = ['Shopee Ads', 'Facebook Ads', 'Booking Group', 'Voucher Tung Group', 'Voucher Shop', 'Gift', 'Tiktok', 'Shopee Live', 'Book KOL/KOC']
        const spike_day = 4
        for (const item of extend) {
          headers.push({
            name: item,
            type: item,
            parent: ''
          })
          for (let i = 1; i <= spike_day; i++) {
            headers.push({
              name: `Spike day ${i}`,
              type: item,
              parent: item
            })
          }
          headers.push({
            name: 'Khác',
            type: item,
            parent: item
          })
        }
        const key = {
          gmv_percent: 0,
          gmv: null,
          cost_percent: 0,
          cost: null,
          order: null,
          cr: null,
          aov: null,
          traffic: null
        }
        for (const item of headers) {
          Object.assign(item, key)
        }
        this.data_target.push(...headers)

        // TODO: Get products
        await this.m__generate_data_product()

        this.m__generate_scrollbar()

        this.copy_column = 'order'
        this.m__confirm_copy_column()

        this.copy_column = 'cr'
        this.m__confirm_copy_column()
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.generate_data = false
      }
    }
  }
}
</script>

<style lang="scss">
.plan-table-normal {
  width: 100%;
  table-layout: auto !important;
  //border: 1px solid #6c6c6c;
  //
  //td, th {
  //  padding: 5px;
  //  border: 1px solid #6c6c6c;
  //}

  th:nth-child(odd), td:nth-child(odd) {
    width: 200px !important;
  }

  th:nth-child(even), td:nth-child(even) {
    width: 200px !important;
  }

  th {
    vertical-align: text-top;
    padding-bottom: 3px;
    border-bottom: 1px solid #6c6c6c;
  }

  td {
    font-size: 12px;
    font-weight: 600;
  }

  td:nth-child(even) {
    color: #6c6c6c;
    font-weight: 700;
  }
}

.invisible-input {
  //input {
  //  width: 100% !important;
  //  height: 100% !important;
  //  border: none !important;
  //}

  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

  input[type=number] {
    -moz-appearance: textfield !important;
  }

  //input:disabled {
  //  background-color: #FFFFFF !important;
  //  border-color: #DCDFE6 !important;
  //  color: #000000 !important;
  //}
}

.cell-style {
  border-left: 3px solid #EBEEF5;
}

.plan-table {
  input {
    padding: 0 10px !important;
  }
}

.cell-not-editable {
  cursor: text;
  height: 29px;
  line-height: 29px;
  border: 1px solid #c0c4cc;
  padding: 0 10px;
  border-radius: 4px;
  overflow: hidden;
}

#main-table-plan-fixed, #main-table-result-fixed, #main-table-report-fixed {
  position: fixed;
  top: 0;
  z-index: -1;

  .el-table__empty-block {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agency/planv2.vue